import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      <nav className="navbar">
        <div className="container">
          <div className="logo">BetaBuyers</div>
          <button onClick={() => navigate('/register')} className="btn-nav">
            Sign In
          </button>
        </div>
      </nav>

      <section className="hero">
        <div className="container">
          <h1>Shape the Future of Products</h1>
          <p>Join our exclusive community of beta testers and get early access to innovative products</p>
          <button onClick={() => navigate('/register')} className="btn-hero">
            Get Started
          </button>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-card">
              <h3>Early Access</h3>
              <p>Be among the first to test new products before they reach the market</p>
            </div>
            <div className="feature-card">
              <h3>Make an Impact</h3>
              <p>Your feedback directly influences product development and improvements</p>
            </div>
            <div className="feature-card">
              <h3>Get Rewarded</h3>
              <p>Receive compensation and exclusive perks for your valuable contributions</p>
            </div>
          </div>
        </div>
      </section>

      <section className="how-it-works">
        <div className="container">
          <h2>How It Works</h2>
          <div className="steps-grid">
            <div className="step">
              <div className="step-number">01</div>
              <h4>Create Account</h4>
              <p>Sign up in seconds with your email or Google account</p>
            </div>
            <div className="step">
              <div className="step-number">02</div>
              <h4>Apply to Test</h4>
              <p>Browse available opportunities and submit your application</p>
            </div>
            <div className="step">
              <div className="step-number">03</div>
              <h4>Test & Provide Feedback</h4>
              <p>Use the product and share your honest, detailed feedback</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>© 2024 BetaBuyers. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;